module.exports = __webpack_public_path__ + "img/bagels_formed.73f00c6d.jpg";